var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconMenuStory = function SvgIconMenuStory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.3,
    y: 3,
    width: 14,
    height: 18,
    rx: 2,
    fill: "#fff",
    stroke: "#343637",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3 6.303a1 1 0 0 1 .168-.555L21.3 3l1.832 2.748a1 1 0 0 1 .168.555V20a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V6.303Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m21.3 3 .624-.416a.75.75 0 0 0-1.248 0L21.3 3Zm1.832 2.748-.624.416.624-.416Zm-3.664 0 .624.416-.624-.416Zm.624.416 1.832-2.748-1.248-.832-1.832 2.748 1.248.832Zm.584-2.748 1.832 2.748 1.248-.832-1.832-2.748-1.248.832Zm1.874 2.887V20h1.5V6.303h-1.5ZM22.3 20.25h-2v1.5h2v-1.5ZM20.05 20V6.303h-1.5V20h1.5Zm.25.25a.25.25 0 0 1-.25-.25h-1.5c0 .966.784 1.75 1.75 1.75v-1.5Zm2.25-.25a.25.25 0 0 1-.25.25v1.5A1.75 1.75 0 0 0 24.05 20h-1.5Zm-.042-13.836a.25.25 0 0 1 .042.139h1.5a1.75 1.75 0 0 0-.294-.971l-1.248.832Zm-3.664-.832a1.75 1.75 0 0 0-.294.97h1.5a.25.25 0 0 1 .042-.138l-1.248-.832Z",
    fill: "#343637"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#343637",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.3 7h4v11h-4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3 7h6M5.3 10h3",
    stroke: "#343637",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgIconMenuStory;